<template>
  <div>
    <div class="blueBanner2">
      <v-layout align-center column justify-center>
        <v-flex xs12 lg12 align-center text-lg-center class="px-3">
          <h1 class="white--text display-2 mt-0 metropolisBold font-weight-bold pb-4">Portfolio</h1>
          <p class="white--text mb-0 headline metropolisMedium">Here’s some sites we’ve made over the last 12 years, small and large</p>
          <p class="white--text headline metropolisMedium">ranging from a couple thousand to millions of dollars. </p>
        </v-flex>
        
      </v-layout>
    </div>
      <div id="portfolio"  class="pb-0 mb-0">
        <div class="tile scale-anm design" style="display:inline-block;" v-for="(team, index) in portfolio" :key="index">
					<figure class="effect-apollo">
						<img :src="team.image" :alt="team.name" />
						<figcaption>
							<h3 class="metropolisMedium ">{{team.name1}} <span class="metropolisBold">{{team.name2}}</span></h3>
							<p class="metropolisBold">{{team.position}}</p>
							<a :href="team.url">View more</a>
						</figcaption>			
					</figure>
        </div>
		</div>


    <!-- <v-container fluid grid-list-lg class="darkTabs">
      <v-layout wrap> 
        <v-flex xs12 align-center text-xs-center>
          <span class="category-links">
            <router-link :to="{name:'CaseStudy'}">All</router-link>
          </span>
          <span v-for="(category,i) in getCaseStudiesCategories" :key="i" class="category-links">
            <router-link :to="{ name: 'CaseStudyCategory', params:{id:i}}">{{i}}</router-link>
          </span>
        </v-flex>
      </v-layout>
    </v-container> -->

  <!-- <v-container class="brand-bg">
      <v-layout justify-center row center>
        <v-flex lg2 md2 xs4 v-for="(review, i) in reviews" :key="i" :name="review.name">
          <img :src="`assets/images/portfolio/`+review.img" width="160px"><br>
        </v-flex>
      </v-layout>
    </v-container> -->

   <!-- <v-container class="brand-bg">
      <v-layout justify-center row text-xs-center>
        <v-flex lg2 md2 xs4 v-for="(review1, i) in reviews1" :key="i" :name="review1.name">
          <img :src="`assets/images/portfolio/`+review1.img" width="160px"><br>
        </v-flex>
      </v-layout>
    </v-container> -->
    <!-- <CaseStudyCategories></CaseStudyCategories> -->
  </div>
</template>

<script>
import CaseStudyCategories from "../components/casestudy/Categories.vue";

import firebase from "@/firebase/index";

// export default {
//   name: "CaseStudy",
//   components: {
//     CaseStudyCategories
//   },
//   data() {
//     return {
//       query: []
//     };
//   },
//   computed: {
//     getCaseStudiesCategories() {
//       return this.$store.getters.getCaseStudiesAll;
//     },
//     queryResult() {
//       if (this.$store.getters.value) {
//         this.query.push(this.$store.dispatch("finalQuery"));
//       }
//     }
//   },

//   methods: {
//     toggleClick(obj) {
//       console.log(obj);
//     }
//   },
//   created() {
//     this.queryResult;

//     firebase
//       .firestore()
//       .collection("case_study")
//       .get()
//       .then(querySnapshot => {
//         querySnapshot.forEach(doc => {
//           console.log(`${doc.id} => ${doc.data()} First query`);
//         });
//         // console.log(querySnapshot, "Firebase Results");
//       });
//   }
// };

export default {
    name: "CaseStudy",
    metaInfo: {
      title: 'Portfolio | Canvas Development', 
      meta: [
          {                 
            name: 'keywords',
            content: 'portfolio'
          },
          {
            name: 'description',
            content:'Here’s some sites we’ve made over the last 12 years, small and large ranging from a couple thousand to millions of dollars. '
          }
      ]
      
    },
    data() {
      return {
        portfolio: [
        {
          image: "https://ik.imagekit.io/canvasdev/upstate-coins-thumb_AWTmAPgQi.jpg",
          name1: "Upstate",
          name2: "Coins",
          position: "Platform Trading System",
          url: "https://upstatecoins.com"
        },
        {
          image: "https://ik.imagekit.io/canvasdev/nulengua-thumb_3Aiby6HQ7.jpg",
          name1: "",
          name2: "Nulengua",
          position: "Customize Lessons",
          url: "https://nulengua.com"
        },
        {
          image: "https://ik.imagekit.io/canvasdev/upstatecoins-gold-center_B3fJyW-vx.jpg",
          name1: "Upstate Coin",
          name2: "& Gold Center",
          position: "Trading Application",
          url: "http://sellyourgoldsyracuse.com"
        },
        {
          image: "https://ik.imagekit.io/canvasdev/amphonorsprograms_JLN16R4RV.jpg",
          name1: "AMP",
          name2: "Honors Program",
          position: "Student Platform System",
          url: "https://amphonorsprogram.com/"
        },
        {
          image: "https://ik.imagekit.io/canvasdev/countdowngames_Tejxx5DzE.jpg",
          name1: "Countdown",
          name2: "Games", 
          position: "Platform Game & Booking",
          url: "https://countdowngames.com"
        },
        {
          image: "https://ik.imagekit.io/canvasdev/blinkpsr_UBqWoatWc.jpg",
          name1: "Blink",
          name2: "PSR",
          position: "Physical Theraphy with Booking",
           url: "http://blinkpsrph.com"
        },
        {
          image: "https://ik.imagekit.io/canvasdev/rawbrown_XrVbbThoSD.jpg",
          name1: "Raw",
          name2: "Brown Sugar",
          position: "Sugar Mill Company",
          url: "https://rawbrownsugar.com.ph"
        },
        {
          image: "https://ik.imagekit.io/canvasdev/villaamani_HkQmulLgM.jpg",
          name1: "Villa",
          name2: "Amani",
          position: "Vacation House with Booking App",
           url: "https://www.villa-amani.com/"
        },
        {
          image: "https://ik.imagekit.io/canvasdev/cheaplittlecigars_t2f33mGK-.jpg",
          name1: "Cheap Little",
          name2: "Cigars",
          position: "eCommerce Platform",
          url: "http://www.cheaplittlecigaroutlet.com/"
        },
        {
          image: "https://ik.imagekit.io/canvasdev/123teach_smnZgDgJgD.jpg",
          name1: "123",
          name2: "Teach Me",
          position: "Learning Web System",
           url: "https://www.123teachme.com/"
        },

        {
          image: "https://ik.imagekit.io/canvasdev/clearview_bDxF9HhPA.jpg",
          name1: "Clear",
          name2: "View",
          position: "Solutions and Customize",
          url: "https://www.clearviewws.com/"
        },
        {
          image: "https://ik.imagekit.io/canvasdev/paperrator_hTnWyqsNo.jpg",
          name1: "Paper",
          name2: "Rater",
          position: "Online Proofreading",
          url: "https://www.paperrater.com/"
        }
      ],
        reviews:[
                {
                  name: 'Upstate Coins',
                  img:'upsatecoin.jpg'
                },
                {
                  name: 'Count Down Games',
                  img:'countdowngames.jpg'

                },
                {
                  name: 'Nulengua',
                  img:'nulengua.jpg'
                },
                {
                  name: 'AMP Honors Program',
                  img:'amp.jpg'
                },
                {
                  name: 'Blink PSR',
                  img:'blink.jpg'

                },
                {
                  name: 'Platform Gold',
                  img:'platformgold.jpg'
                }
              ],
               reviews1:[
                 {
                  name: 'Yeis',
                  img:'yeis.jpg'
                },
                {
                  name: 'C Little Cigars',
                  img:'cheap.jpg'

                },
                {
                  name: 'Crealtor',
                  img:'crealtor.jpg'
                },
                {
                  name: 'OuiboxPro',
                  img:'ouibx.jpg'
                },
                {
                  name: 'RBS',
                  img:'rbs.jpg'
                },
                {
                  name: 'Villa Amani',
                  img:'villa-amani.jpg'
                }
              ],
             
                 };
    }
  };
</script>

<style scoped>
.footerstyle {margin-top:-40px !important;}
.category-links a {
  text-transform: uppercase;
  display: inline-block;
  margin-right: 100px;
}

.router-link-exact-active {
  font-weight: 700;
  text-decoration: underline;
  color: #ba68c8;
}

.blueBanner2 {
  background: rgba(48, 48, 137) url("https://ik.imagekit.io/canvasdev/works-header-banner_oAODcIdHi.jpg") no-repeat;
  background-position: center;
  background-size: cover;
  padding: 200px 0;
  color: #fff;
}

.darkTabs{
  background-color:#141519;
}

.darkTabs .category-links a{
  color:#FFF;
  font-weight: 400;
  font-size:16px;
}
.border1 {border:1px solid #ccc;}
</style>

